/**
 * @file index.tsx
 *
 * @fileoverview Renders a Horizontal card paragraph type as LP row.
 */

import React from 'react';
import { HorizontalCardParagraph } from '~/jobiqo/types/types';
import Box from '~/vcl/atoms/07-box';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import HorizontalCard from '~/jobiqo/components/Landingpage/CardsSlider/components/HorizontalCard';

interface HorizontalCardRowProps {
  /**
   * The horizontal card paragraph.
   */
  row: HorizontalCardParagraph;
  /**
   * The background color of LP entity.
   */
  backgroundColor?: string;
  /**
   * The max container size from LP entity.
   */
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}

export const HorizontalCardRow = ({
  row,
  backgroundColor,
  maxContainerSize,
}: HorizontalCardRowProps) => {
  return (
    <Box
      boxShadow="none"
      borderRadius="0px"
      margin={0}
      padding={8}
      backgroundColorOverride={
        backgroundColor ? `var(--color-${backgroundColor})` : 'transparent'
      }
    >
      <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
        <HorizontalCard card={row} />
      </Main>
    </Box>
  );
};

export default HorizontalCardRow;
